import { Navigate } from "react-router-dom";

import { SUPPLIES_PATHS } from "@/features/supplies/constants";

/** The cart is a drawer now; the old page link opens it over the catalogue. */
export const SuppliesCartRedirect = () => (
  <Navigate replace to={SUPPLIES_PATHS.cartPanel} />
);
